import BaseService from "../CorBase/BaseService";
import BaseFilter from '../CorBase/BaseFilter';

export class TariffService extends BaseService {
	constructor() {
		super('/Tariff');
	}

	public deleteList(list: number[]) {
		return this.deleteListWithResourceName(list, 'delete-list')
	}

	public getAllByFilter(filter: TariffFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class TariffFilter extends BaseFilter {
	constructor(name?: string | null) {
		super();

		this._name = name;
	}

	private _name?: string | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._name != null ? { Name: this._name } : {})

		);

		return data;
	};
}